<template>
  <div class="firmware px">
    <c-mouse-electricity
      v-if="percent < 0"
      ref="mouseFirmwareElectricity"
      style="visibility: hidden;"
    />
    <c-password
      @select="localFirmware"
      :onBack="
        () => {
          resumeFirmwareBatteryGuard('firmwarePassword', { refresh: true });
          passwordVisible = false;
          type = '';
        }
      "
      v-if="passwordVisible"
    />
    <template v-else>
      <img class="logo" :src="images.logo_white" />
      <template v-if="$route.path.includes('/dongle-mouse')">
        <div class="title" @click="handleVersionTitleClick">
          Dongle
          <span> *{{ $t("mouse.connect", [$t("mouse.name")]) }}</span>
          <div class="code">
            {{ dongleVersion }}
          </div>
        </div>
        <div class="dongle-version" :class="{ close: isClose }">
          <div class="version" @click="type = newDUSBVersion ? 'd_usb' : ''">
            <div class="name">
              {{ $t("loader.USBVersion") }}
              <img class="new" :src="images.icon_new" v-show="newDUSBVersion" />
            </div>
            <div class="code" @click.stop="showPassword('d_usb')">
              <i class="iconfont iconupload-folder" /> {{ currentDUSBVersion }}
            </div>
            <div class="radio" :class="{ active: type == 'd_usb' }"></div>
          </div>
          <div class="version" @click="type = newDSOCVersion ? 'd_soc' : ''">
            <div class="name">
              {{ $t("loader.SoCVersion") }}
              <img class="new" :src="images.icon_new" v-show="newDSOCVersion" />
            </div>
            <div class="code" @click.stop="showPassword('d_soc')">
              <i class="iconfont iconupload-folder" /> {{ currentDSOCVersion }}
            </div>
            <div class="radio" :class="{ active: type == 'd_soc' }"></div>
          </div>
          <div class="version" @click="type = newDLEDVersion ? 'd_led' : ''">
            <div class="name">
              {{ $t("loader.LEDVersion") }}
              <img class="new" :src="images.icon_new" v-show="newDLEDVersion" />
            </div>
            <div class="code" @click.stop="showPassword('d_led')">
              <i class="iconfont iconupload-folder" /> {{ currentDLEDVersion }}
            </div>
            <div class="radio" :class="{ active: type == 'd_led' }"></div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="title" @click="handleVersionTitleClick">
          {{ $t("mouse.name") }}
          <span> *{{ $t("mouse.connect", [" Dongle "]) }}</span>
          <div class="code">
            {{ mouseVersion }}
          </div>
        </div>
        <div class="mouse-version" :class="{ close: isClose }">
          <div class="version" @click="type = newUSBVersion ? 'usb' : ''">
            <div class="name">
              {{ $t("loader.USBVersion") }}
              <img class="new" :src="images.icon_new" v-show="newUSBVersion" />
            </div>
            <div class="code" @click.stop="showPassword('usb')">
              <i class="iconfont iconupload-folder" /> {{ currentUSBVersion }}
            </div>
            <div class="radio" :class="{ active: type == 'usb' }"></div>
          </div>
          <div class="version" @click="type = newSoCVersion ? 'soc' : ''">
            <div class="name">
              {{ $t("loader.SoCVersion") }}
              <img class="new" :src="images.icon_new" v-show="newSoCVersion" />
            </div>
            <div class="code" @click.stop="showPassword('soc')">
              <i class="iconfont iconupload-folder" /> {{ currentSoCVersion }}
            </div>
            <div class="radio" :class="{ active: type == 'soc' }"></div>
          </div>
        </div>
      </template>
      <div class="button" @click="updateFirmware(type)" :disabled="!hasNew">
        {{ $t("loader.update") }}
      </div>
      <div class="tip" v-html="$t('mouse.updateTip')"></div>
    </template>
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="progressText"
      :image="images['device_mouse']"
      @close="percent = -1"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deviceCallbackManager } from '@/utils/DeviceCallbackManager';
import firmwareSecretTap from "./firmwareSecretTap";

const { createFirmwareSecretTapGate } = firmwareSecretTap;

export default {
  data() {
    return {
      percent: -1,
      progressText: "",
      type: "",
      isClose: true,
      passwordVisible: false,
      mouseVersion: "V0.0.0",
      dongleVersion: "V0.0.0",
      currentSoCVersion: "V0.0.0",
      currentUSBVersion: "V0.0.0",
      currentDSOCVersion: "V0.0.0",
      currentDUSBVersion: "V0.0.0",
      currentDLEDVersion: "V0.0.0",
      newUSBVersion: 0,
      newSoCVersion: 0,
      newDUSBVersion: 0,
      newDSOCVersion: 0,
      newDLEDVersion: 0,
      versionTitleTapGate: createFirmwareSecretTapGate(),
      firmwareBatteryGuardFallbackTimer: null,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    hasNew() {
      return (
        this.newUSBVersion +
          this.newSoCVersion +
          this.newDUSBVersion +
          this.newDSOCVersion +
          this.newDLEDVersion >
        0
      );
    },
  },
  mounted() {
    this.$store.dispatch("loader/setInLoader", true);
    this.$store.dispatch("loader/getCurrentVer");
    this.$store.dispatch("loader/setLoading", true);
    this.subscribeToHostEvents();
  },
  beforeDestroy() {
    this.unsubscribeFromHostEvents();
    this.clearFirmwareBatteryGuardFallbackTimer();
  },
  methods: {
    clearFirmwareBatteryGuardFallbackTimer() {
      if (this.firmwareBatteryGuardFallbackTimer) {
        clearTimeout(this.firmwareBatteryGuardFallbackTimer);
        this.firmwareBatteryGuardFallbackTimer = null;
      }
    },
    pauseFirmwareBatteryGuard(source) {
      const electricity = this.$refs.mouseFirmwareElectricity;
      if (
        electricity &&
        typeof electricity.pauseBatteryGuard === "function"
      ) {
        electricity.pauseBatteryGuard(source);
      }
      this.clearFirmwareBatteryGuardFallbackTimer();
      // 当前宿主没有“本地选文件取消”的明确回调。
      // 如果用户取消文件选择，这里需要兜底恢复电量守卫，
      // 避免固件页长期失去电量轮询与离线检测能力。
      this.firmwareBatteryGuardFallbackTimer = setTimeout(() => {
        this.resumeFirmwareBatteryGuard(source, { refresh: true });
      }, 120000);
    },
    resumeFirmwareBatteryGuard(source, options = {}) {
      const electricity = this.$refs.mouseFirmwareElectricity;
      this.clearFirmwareBatteryGuardFallbackTimer();
      if (
        electricity &&
        typeof electricity.resumeBatteryGuard === "function"
      ) {
        electricity.resumeBatteryGuard(source, options);
      }
    },
    handleVersionTitleClick() {
      if (this.versionTitleTapGate.registerTap()) {
        this.isClose = !this.isClose;
      }
    },
    updateFirmware(type) {
      if (!this.hasNew) return;
      type = this.$route.path.includes("/dongle-mouse") ? "d_usb" : "usb";
      this.pauseFirmwareBatteryGuard("firmwareUpdate");
      this.$store.dispatch("loader/autoMouseUpdate", type);
    },
    showPassword(type) {
      this.pauseFirmwareBatteryGuard("firmwarePassword");
      this.passwordVisible = true;
      this.type = type;
    },
    localFirmware() {
      this.resumeFirmwareBatteryGuard("firmwarePassword");
      this.passwordVisible = false;
      this.pauseFirmwareBatteryGuard("firmwareUpdate");
      this.$store.dispatch("loader/localMouseUpdate", this.type);
    },
    subscribeToHostEvents() {
      deviceCallbackManager.subscribe('updateCurrentVer', this.onHostUpdateCurrentVer);
      deviceCallbackManager.subscribe('updateFinish', this.onHostUpdateFinish);
      deviceCallbackManager.subscribe('updateMouseProgress', this.onHostUpdateMouseProgress);
    },
    unsubscribeFromHostEvents() {
      deviceCallbackManager.unsubscribe('updateCurrentVer', this.onHostUpdateCurrentVer);
      deviceCallbackManager.unsubscribe('updateFinish', this.onHostUpdateFinish);
      deviceCallbackManager.unsubscribe('updateMouseProgress', this.onHostUpdateMouseProgress);
    },
    onHostUpdateCurrentVer(json) {
      console.log("Bridge", "updateCurrentVer", "Start", json);
      if (json) {
        const data = JSON.parse(json);
        this.mouseVersion = data.mouseVersion;
        this.dongleVersion = data.dongleVersion;
        this.currentSoCVersion = data.currentSoCVersion;
        this.currentUSBVersion = data.currentUSBVersion;
        this.currentDSOCVersion = data.currentDSOCVersion;
        this.currentDUSBVersion = data.currentDUSBVersion;
        this.currentDLEDVersion = data.currentDLEDVersion;
        this.newUSBVersion = data.newUSBVersion || 0;
        this.newSoCVersion = data.newSoCVersion || 0;
        this.newDUSBVersion = data.newDUSBVersion || 0;
        this.newDSOCVersion = data.newDSOCVersion || 0;
        this.newDLEDVersion = data.newDLEDVersion || 0;
        console.log("Bridge", "updateCurrentVer", "End");
        this.resumeFirmwareBatteryGuard("firmwareUpdate", { refresh: true });
        this.$store.dispatch("loader/setLoading", false);
      }
    },
    onHostUpdateFinish() {
      setTimeout(() => {
        this.$store.dispatch("loader/getCurrentVer");
      }, 2000);
    },
    onHostUpdateMouseProgress(json) {
      console.log("----------------", new Date().getTime(), "----------------");
      if (json) {
        console.log(json);
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText =
          (this.isCN ? data.message.zh_CN : data.message.en_US) || "";
        if (this.percent >= 0) {
          this.clearFirmwareBatteryGuardFallbackTimer();
        }
        console.log(this.percent);
        if (this.percent >= 100) {
          this.progressText = this.$t("loader.updateSuccess")
          // this.$store.dispatch("loader/getCurrentVer");
        } else if (this.percent === -1) {
          this.resumeFirmwareBatteryGuard("firmwareUpdate", { refresh: true });
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.firmware {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 30px;
  }

  .title {
    width: 720px;
    font-size: 30px;
    padding-bottom: 5px;
    margin-bottom: 20px;
    border-bottom: 1px solid $primary-color;
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      font-size: 16px;
      color: $active-color;
      letter-spacing: 0.5px;
      margin-left: 5px;
      height: 30px;
      line-height: 45px;
      flex: auto;
    }

    .code {
      flex: none;
      font-size: 22px;
      color: #3c3c3c;
      flex: none;
    }
  }

  .mouse-version {
    height: 180px;
    overflow: hidden;
    transition: height 0.56s cubic-bezier(0.52, 0.16, 0.24, 1);
    margin-bottom: 30px;

    &.close {
      height: 0;
    }
  }

  .dongle-version {
    height: 290px;
    overflow: hidden;
    transition: height 0.56s cubic-bezier(0.52, 0.16, 0.24, 1);
    margin-bottom: 30px;

    &.close {
      height: 0;
    }
  }

  .version {
    @include flex-center;
    justify-content: flex-end;
    width: 720px;
    padding: 10px 0;
    border-bottom: 3px solid #1d1d1d;
    font-size: 26px;
    margin-bottom: 40px;

    .name {
      width: 80%;
      flex: auto;
      cursor: pointer;
    }

    .code {
      font-size: 24px;
      color: #3c3c3c;
      flex: none;
      margin-right: 15px;
      cursor: pointer;

      .iconfont {
        font-size: 28px;
      }
    }

    .new {
      width: 56px;
      vertical-align: text-top;
      margin-top: -10px;
    }

    .radio {
      width: 30px;
      height: 30px;
      border: 2px solid #3c3c3c;
      border-radius: 50%;
      padding: 3px;
      margin-right: 30px;
      flex: none;
      cursor: pointer;
      display: none;

      &.active::before {
        width: 100%;
        height: 100%;
        display: block;
        content: "";
        background-color: $primary-color;
        border-radius: 50%;
      }
    }
  }

  .description {
    width: 720px;
    height: 250px;
    word-break: break-all;
    white-space: pre-wrap;
    font-size: 28px;
    overflow-y: auto;
    margin-bottom: 30px;
  }

  .button {
    @include linear-button;
    width: 200px;
    height: 60px;
    line-height: 60px;
    font-size: 28px;
  }

  .tip {
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    text-align: center;
    margin-top: 40px;
    color: #666666;
  }
}
</style>
